<template>
  <div>
    <div class="summary-tables">
      <table class="summary-table">
        <tr :class="['missing-row', { 'has-missing': missingUsers().length > 0 }]">
          <th>Fehlende Wochenlisten:</th>
          <td>{{ missingUsers().length }}</td>
        </tr>
      </table>
    </div>
    <div class="additional-content">
      <button @click="handleSendSMS" :disabled="isLoadingSMS || isLoadingWhatsApp || missingUsers().length === 0">
        <span v-if="isLoadingSMS" class="spinner-wrap">
          <span class="spinner"></span>
        </span>
        <span v-else>
          SMS versenden
        </span>
      </button>
    </div>
    <div id="hot"></div>
  </div>
</template>

<script>
import PVDataTable from './PVDataTable.vue';
import axios from "axios";
import config from "@/config/config";

export default {
  name: 'PVDataTableAbgabe',
  extends: PVDataTable,
  data() {
    return {
      isLoadingSMS: false,
      isLoadingWhatsApp: false
    };
  },
  methods: {
    missingUsers() {
      return this.data.filter(user => user.has_entry === "FEHLT");
    },
    handleSendSMS() {
      this.sendMessages(config.SEND_MESSAGES_URL, 'sms');
    },
    async sendMessages(url, type) {
      const missingUsers = this.missingUsers();
      if (missingUsers.length === 0) {
        this.$root.showToast('error', config.ERROR_NO_MISSING_USERS);
        return;
      }

      if (type === 'sms') {
        this.isLoadingSMS = true;
      }

      const params = new URLSearchParams();
      params.append('users', JSON.stringify(missingUsers));
      params.append('type', type);

      try {
        const response = await axios.post(url, params);

        if (response.data.success) {
          const count = response.data.data.messages_sent;
          this.$root.showToast('success', `${config.MESSAGES.SUCCESS_MESSAGES} ${count} ${type.toUpperCase()}-Nachrichten.`);
        } else {
          this.$root.showToast('error', response.data.error || config.MESSAGES.ERROR);
        }
        this.isLoadingSMS = this.isLoadingWhatsApp = false;
      } catch (error) {
        this.isLoadingSMS = this.isLoadingWhatsApp = false;
        this.$root.showToast('error', `${config.MESSAGES.ERROR_MESSAGES} ${error.message}`);
      }
    }
  },
};
</script>
<style>
.additional-content {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.additional-content button {
  min-width: 180px;
  min-height: 40px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.additional-content button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.additional-content button:hover {
  background-color: #0056b3;
}

.additional-content button:hover:disabled {
  background-color: #6c757d;
}

.spinner-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 10px;
  height: 10px;
  border: 1px solid white;
  border-top-color: transparent;
  border-radius: 50%;
  display: block;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.missing-row {
  background-color: #4caf50;
  color: white;
}
.missing-row.has-missing {
  font-weight: bold;
  background-color: #f44343; /* Default color is red */
}
</style>
